import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSelectedSubscription } from '../apiCalls/subscription'

export const fetchSubscriptionById = createAsyncThunk(
  "subscription/fetchById",
  async (id) => {
    const res = await getSelectedSubscription(id);
    console.log(res, 'we get')
    return res;
  }
);

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    subscriptions: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getSubscriptionStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getSubscriptionSuccess: (state, action) => {
      state.isFetching = false;
      state.subscriptions = action.payload;
    },
    getSubscriptionFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionById.pending, (state) => {
        state.isFetching = true;
        state.error = false;
      })
      .addCase(fetchSubscriptionById.fulfilled, (state, action) => {
        state.isFetching = false;
        state.selectedSubscription = action.payload;
      })
      .addCase(fetchSubscriptionById.rejected, (state) => {
        state.isFetching = false;
        state.error = true;
      });
  },
});

export const {
  getSubscriptionStart,
  getSubscriptionSuccess,
  getSubscriptionFailure,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
